import ethers from 'assimilation/symbiosis/ethers/sagas'
import uport from 'assimilation/symbiosis/uport/sagas'
export default [
  ethers(),
  uport(),
]


// WEBPACK FOOTER //
// ./src/core/assimilation/symbiosis/sagas.js